export default __webpack_public_path__ + "static/media/rec3dgaussian.70a1921f.jpg";